import { render, staticRenderFns } from "./ReportingRestrictionsItem.vue?vue&type=template&id=7c510231&"
import script from "./ReportingRestrictionsItem.vue?vue&type=script&lang=js&"
export * from "./ReportingRestrictionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports